import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
export function Footer() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const currentYear = new Date().getFullYear();
  return <footer className="py-12 border-t border-[#1a1f2e] bg-[#0f1419] text-center" data-id="element-13">
      <div className="max-w-4xl mx-auto px-4" data-id="element-14">
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm text-gray-500" data-id="element-15">
          <p data-id="element-16">
            © {currentYear} Sueño Sin Dolor. Todos los derechos reservados.
          </p>

          <div className="hidden md:block w-1 h-1 rounded-full bg-gray-700" data-id="element-17" />

          <button onClick={() => setIsPrivacyOpen(true)} className="hover:text-[#d4af37] transition-colors focus:outline-none focus:text-[#d4af37]" data-id="element-18">
            Política de Privacidad
          </button>

          <div className="hidden md:block w-1 h-1 rounded-full bg-gray-700" data-id="element-19" />

          <button onClick={() => setIsTermsOpen(true)} className="hover:text-[#d4af37] transition-colors focus:outline-none focus:text-[#d4af37]" data-id="element-20">
            Términos y Condiciones
          </button>
        </div>
      </div>

      {/* Privacy Policy Modal */}
      <Modal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} title="Política de Privacidad" data-id="element-21">
        <div className="space-y-4 text-sm md:text-base" data-id="element-22">
          <p data-id="element-23">Última actualización: {currentYear}</p>

          <h3 className="text-[#d4af37] font-bold text-lg mt-6" data-id="element-24">
            1. Introducción
          </h3>
          <p data-id="element-25">
            En Sueño Sin Dolor, respetamos su privacidad y nos comprometemos a
            proteger sus datos personales. Esta política de privacidad le
            informará sobre cómo cuidamos sus datos personales cuando visita
            nuestro sitio web y le informará sobre sus derechos de privacidad y
            cómo la ley lo protege.
          </p>

          <h3 className="text-[#d4af37] font-bold text-lg mt-6" data-id="element-26">
            2. Datos que recopilamos
          </h3>
          <p data-id="element-27">
            Podemos recopilar, usar, almacenar y transferir diferentes tipos de
            datos personales sobre usted, que hemos agrupado de la siguiente
            manera:
          </p>
          <ul className="list-disc pl-5 space-y-2" data-id="element-28">
            <li data-id="element-29">
              <strong data-id="element-30">Datos de identidad:</strong> incluye nombre, apellido,
              nombre de usuario o identificador similar.
            </li>
            <li data-id="element-31">
              <strong data-id="element-32">Datos de contacto:</strong> incluye dirección de correo
              electrónico.
            </li>
            <li data-id="element-33">
              <strong data-id="element-34">Datos técnicos:</strong> incluye dirección de protocolo de
              internet (IP), tipo y versión de navegador, configuración de zona
              horaria y ubicación.
            </li>
            <li data-id="element-35">
              <strong data-id="element-36">Datos de uso:</strong> incluye información sobre cómo
              utiliza nuestro sitio web, productos y servicios.
            </li>
          </ul>

          <h3 className="text-[#d4af37] font-bold text-lg mt-6" data-id="element-37">
            3. Cómo usamos sus datos
          </h3>
          <p data-id="element-38">
            Solo utilizaremos sus datos personales cuando la ley nos lo permita.
            Lo más común es que usemos sus datos personales en las siguientes
            circunstancias:
          </p>
          <ul className="list-disc pl-5 space-y-2" data-id="element-39">
            <li data-id="element-40">
              Donde necesitemos ejecutar el contrato que estamos a punto de
              celebrar o hemos celebrado con usted.
            </li>
            <li data-id="element-41">
              Donde sea necesario para nuestros intereses legítimos (o los de un
              tercero) y sus intereses y derechos fundamentales no anulen esos
              intereses.
            </li>
            <li data-id="element-42">
              Donde necesitemos cumplir con una obligación legal o
              reglamentaria.
            </li>
          </ul>

          <h3 className="text-[#d4af37] font-bold text-lg mt-6" data-id="element-43">
            4. Seguridad de los datos
          </h3>
          <p data-id="element-44">
            Hemos implementado medidas de seguridad adecuadas para evitar que
            sus datos personales se pierdan accidentalmente, se usen o se acceda
            a ellos de manera no autorizada, se alteren o se divulguen. Además,
            limitamos el acceso a sus datos personales a aquellos empleados,
            agentes, contratistas y otros terceros que tengan una necesidad
            comercial de conocerlos.
          </p>

          <h3 className="text-[#d4af37] font-bold text-lg mt-6" data-id="element-45">
            5. Retención de datos
          </h3>
          <p data-id="element-46">
            Solo conservaremos sus datos personales durante el tiempo que sea
            necesario para cumplir con los fines para los que los recopilamos,
            incluso para cumplir con cualquier requisito legal, contable o de
            informes.
          </p>
        </div>
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} title="Términos y Condiciones" data-id="element-47">
        <div className="space-y-4 text-sm md:text-base" data-id="element-48">
          <p data-id="element-49">Última actualización: {currentYear}</p>

          <h3 className="text-[#d4af37] font-bold text-lg mt-6" data-id="element-50">
            1. Aceptación de los términos
          </h3>
          <p data-id="element-51">
            Al acceder y utilizar este sitio web, usted acepta estar sujeto a
            estos Términos y Condiciones de uso, todas las leyes y regulaciones
            aplicables, y acepta que es responsable del cumplimiento de las
            leyes locales aplicables. Si no está de acuerdo con alguno de estos
            términos, tiene prohibido usar o acceder a este sitio.
          </p>

          <h3 className="text-[#d4af37] font-bold text-lg mt-6" data-id="element-52">
            2. Licencia de uso
          </h3>
          <p data-id="element-53">
            Se concede permiso para descargar temporalmente una copia de los
            materiales (información o software) en el sitio web de Sueño Sin
            Dolor solo para visualización transitoria personal y no comercial.
            Esta es la concesión de una licencia, no una transferencia de
            título, y bajo esta licencia usted no puede:
          </p>
          <ul className="list-disc pl-5 space-y-2" data-id="element-54">
            <li data-id="element-55">Modificar o copiar los materiales;</li>
            <li data-id="element-56">
              Utilizar los materiales para cualquier propósito comercial o para
              cualquier exhibición pública (comercial o no comercial);
            </li>
            <li data-id="element-57">
              Intentar descompilar o aplicar ingeniería inversa a cualquier
              software contenido en el sitio web;
            </li>
            <li data-id="element-58">
              Eliminar cualquier derecho de autor u otras notaciones de
              propiedad de los materiales; o
            </li>
            <li data-id="element-59">
              Transferir los materiales a otra persona o "reflejar" los
              materiales en cualquier otro servidor.
            </li>
          </ul>

          <h3 className="text-[#d4af37] font-bold text-lg mt-6" data-id="element-60">
            3. Descargo de responsabilidad
          </h3>
          <p data-id="element-61">
            Los materiales en el sitio web de Sueño Sin Dolor se proporcionan
            "tal cual". Sueño Sin Dolor no ofrece garantías, expresas o
            implícitas, y por la presente renuncia y niega todas las demás
            garantías, incluidas, entre otras, las garantías implícitas o las
            condiciones de comerciabilidad, idoneidad para un propósito
            particular o no infracción de la propiedad intelectual u otra
            violación de derechos.
          </p>
          <p className="mt-2 font-medium text-gray-200" data-id="element-62">
            Importante: El contenido proporcionado en este sitio web y en
            nuestros productos es solo para fines informativos y educativos. No
            sustituye el consejo, diagnóstico o tratamiento médico profesional.
            Siempre busque el consejo de su médico u otro proveedor de salud
            calificado con cualquier pregunta que pueda tener sobre una
            condición médica.
          </p>

          <h3 className="text-[#d4af37] font-bold text-lg mt-6" data-id="element-63">
            4. Limitaciones
          </h3>
          <p data-id="element-64">
            En ningún caso Sueño Sin Dolor o sus proveedores serán responsables
            de ningún daño (incluidos, entre otros, daños por pérdida de datos o
            ganancias, o debido a la interrupción del negocio) que surjan del
            uso o la imposibilidad de usar los materiales en el sitio web,
            incluso si Sueño Sin Dolor o un representante autorizado ha sido
            notificado oralmente o por escrito de la posibilidad de tal daño.
          </p>

          <h3 className="text-[#d4af37] font-bold text-lg mt-6" data-id="element-65">
            5. Modificaciones
          </h3>
          <p data-id="element-66">
            Sueño Sin Dolor puede revisar estos términos de servicio para su
            sitio web en cualquier momento sin previo aviso. Al utilizar este
            sitio web, usted acepta estar sujeto a la versión actual de estos
            términos de servicio.
          </p>
        </div>
      </Modal>
    </footer>;
}